import store from "@/redux/store";
import { connect } from "react-redux";
import {getTasks, saveTask, newTaskEvent, setChangedItems, setUpdate, getUserSchedules} from '@/reducers/CommunicationCycle';
import React, { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { Overview } from "@/views/Agenda/Overview";
import { show } from '@/reducers/Modal'
import {COMCYCLE} from "@/actions/globalConst";
import BaseController from "@/controllers/BaseController";
import { useTranslation } from "react-i18next";

class AgendaController extends BaseController {
  constructor(props) {
    super(props);
    this.needUpdate = false;
    this.onSaveHandler = this.onSaveHandler.bind(this);
    this.onNewItemHandler = this.onNewItemHandler.bind(this);
  }

   componentDidMount() {
       const {items} = this.props;
       if(this.props.apiState == COMCYCLE.API_INIT || !items) {
           if(!this.props?.viewType) {
            store.dispatch(getTasks({viewType: this.props?.viewType}));
            } else {
            store.dispatch( getUserSchedules({}) );
           }
           //store.dispatch( dossierStore({}) )
        }
       this.needUpdate = true;
   };

    shouldComponentUpdate(nextProps, nextState){
              this.needUpdate = this.props.needToUpdate;
        //store.dispatch(setUpdate(false)); 
        if(this.props.apiState == COMCYCLE.API_REFRESH || (nextProps && nextProps.apiState == COMCYCLE.API_REFRESH )) {
            this.needUpdate = true;
            
            }
        return this.needUpdate;
    }

    
    onSaveHandler(data, index) {
        store.dispatch( setChangedItems({item: data, index:index    }) );
        store.dispatch( saveTask(data) );
        //this.needUpdate = true;
            //this.props.navi("/roles/", {replace: true});

    }
    
    onNewItemHandler(event, eventTypeId) {
        store.dispatch( newTaskEvent(eventTypeId) );
        
    }
    
    
  render() {
          if(this.props.apiState == COMCYCLE.API_READY || this.props.apiState == COMCYCLE.API_REFRESH) {
              store.dispatch(setUpdate(false));
          } else {
//              store.dispatch(setUpdate(true));
          }
          

    return (
      <Overview key={this.props.dataKey} {...this.props}  onSaveHandler={this.onSaveHandler} onNewItemHandler={this.onNewItemHandler} />
    );
      if(this.props.apiState != COMCYCLE.API_INIT) return(<></>);
  }
}

const AgendaControllerInit = (props) => {
    let { id } = useParams();
    let view = "";
    const navi = useNavigate();
    const { t, i18n, ready } = useTranslation();
    
  return (
    <AgendaController
      {...props}
      selectedId={id}
      navi={navi}
      trans={t}
    />
  );
};

function mapStateToProps(state) {
  const {AuthReducer, CommunicationCycleReducer} = state;
  const {items, view, apiState, key, calenderSettings, priority, event_types,needToUpdate,selectedDate, users, selectedUsers, usersSchedules} = CommunicationCycleReducer;
  return {
      items: items,
      priority: priority,
      event_types: event_types,
      view,
      apiState,
      dataKey: key,
      calenderSettings: calenderSettings,
      needToUpdate: needToUpdate,
      selectedDate: selectedDate,
      users: users,
      selectedUsers: selectedUsers,
      usersSchedules: usersSchedules
  };
}
export default connect(mapStateToProps)(AgendaControllerInit);
